import React from 'react';

/**
 * APEX Design System — SectionLabel
 *
 * Pattern signature d'APEX : label uppercase letterspaced + barre gradient.
 *
 * Variants:
 *   - default : barre cyan→fuchsia (signature)
 *   - small   : juste le label, sans barre
 *   - cyan    : barre cyan plein
 *   - rose    : barre rose plein (danger)
 *   - violet  : barre violet plein (rank)
 *
 * Props:
 *   - children : le texte du label
 *   - icon     : icône à droite du label (optionnel)
 *   - subtext  : ligne en dessous (optionnel)
 *
 * Usage:
 *   <SectionLabel icon={<Trophy size={11} />}>
 *     Performance Lane
 *   </SectionLabel>
 *
 *   <SectionLabel variant="rose" subtext="à éviter en priorité">
 *     Morts Coûteuses
 *   </SectionLabel>
 */

const BARS = {
  default: 'bg-gradient-to-b from-cyan-400 to-fuchsia-400',
  cyan: 'bg-cyan-400',
  rose: 'bg-rose-400',
  violet: 'bg-violet-400',
  amber: 'bg-amber-400'
};

export default function SectionLabel({
  children,
  variant = 'default',
  icon,
  subtext,
  className = ''
}) {
  const showBar = variant !== 'small';

  return (
    <div className={`${className}`}>
      <div className="flex items-center gap-3">
        {showBar && (
          <div className={`w-1 h-6 ${BARS[variant]} shrink-0`} />
        )}
        <h2 className="text-[10px] tracking-[0.4em] text-zinc-500 uppercase font-semibold flex items-center gap-2">
          {children}
          {icon && <span className="opacity-80">{icon}</span>}
        </h2>
      </div>
      {subtext && (
        <div className={`text-[10px] text-zinc-600 font-mono mt-1 ${showBar ? 'ml-4' : ''}`}>
          {subtext}
        </div>
      )}
    </div>
  );
}
